import { render, staticRenderFns } from "./NoticeEdit.vue?vue&type=template&id=f1d7916a&scoped=true"
import script from "./NoticeEdit.vue?vue&type=script&lang=js"
export * from "./NoticeEdit.vue?vue&type=script&lang=js"
import style0 from "./NoticeEdit.vue?vue&type=style&index=0&id=f1d7916a&prod&lang=scss"
import style1 from "./NoticeEdit.vue?vue&type=style&index=1&id=f1d7916a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d7916a",
  null
  
)

export default component.exports